"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _Item = _interopRequireDefault(require("../Item/Item.styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Back = function Back(_ref) {
  var icon = _ref.icon,
      label = _ref.label;
  var css = (0, _Item.default)();
  if (!label) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);

  var handleClick = function handleClick() {
    window.history.back();
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "mco-breadcrumb-item"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.link, "mco-breadcrumb-item__link"),
    onClick: handleClick
  }, icon && /*#__PURE__*/_react.default.createElement("span", {
    className: "mco-breadcrumb-item__icon"
  }, icon), /*#__PURE__*/_react.default.createElement("span", {
    className: "mco-breadcrumb-item__label",
    dangerouslySetInnerHTML: {
      __html: label
    }
  })));
};

var _default = Back;
exports.default = _default;